import moment from 'moment'
import { useMemo } from 'react'

import { Item } from '../../models/Item'
import { getDateLabelForAvailability } from '../../utils/calendar'
import { TIME_FORMAT } from '../../utils/dates'
import { Icon } from '../Icon'
import Label from '../app/design/Label'

type Props = {
    date: moment.Moment
    start: moment.Moment
    duration: number
    selectedItem: Item | null | undefined
}

export const CalendarScheduleDateLabel = ({ date, start, duration, selectedItem }: Props) => {
    const dateLabel = useMemo(
        () => getDateLabelForAvailability(date, duration, true),
        [date, duration]
    )

    const timelabel = useMemo(() => {
        const startTime = start.format(TIME_FORMAT)
        const endTime = moment(start).clone().add(duration, 'minutes').format(TIME_FORMAT)

        // TODO: need correct check out time from availability backend rather than just adding duration
        return selectedItem?.type === 'reservation'
            ? `Check-in ${startTime}, Check-out ${endTime}`
            : `${startTime} - ${endTime}`
    }, [selectedItem, start, duration])

    const isRecurring = useMemo(
        () => selectedItem?.type === 'class' && selectedItem?.classType !== 'dropin',
        [selectedItem]
    )

    return (
        <div className="flex items-center gap-4">
            <Icon icon="calendar.medium" />

            <div className="flex flex-col gap-1">
                <Label className="flex items-center gap-2 text-gray-700">
                    {dateLabel} {isRecurring && <Icon icon="repeat.small" />}
                </Label>
                <Label className="text-gray-600">{timelabel}</Label>
            </div>
        </div>
    )
}
